export default "<ace-editor [(text)]=\"text\" #editor class=\"codeviewer-container\"></ace-editor>\r\n"